/*
 * common / showMore
 */

export function initShowMore(singularTxt, pluralTxt) {
  // 初期化処理
  $('.s-more_text').off('click').removeClass('is-open').removeAttr('style');
  $('.s-more_baloon').removeClass('is-open').find('.s-more_baloon_triangle').removeAttr('style');
  $('.s-more_baloon_list_wrap').empty();
  $('.s-more_list').show();
  $('.s-more_text').removeClass('is-show');
  $('.s-more_baloon_close').off('click');
  $(document).off('click', '.s-more_list_wrap, .s-more_baloon');
  $(window).off('resize.showMore');

  // テキストの変更
  $('.s-more_list_wrap').each(function () {
    const $listWrap = $(this);
    const count = $listWrap.find('.s-more_list').length;
    let moreItems;

    if (count > 1) {

      $listWrap.find('.s-more_text').addClass('is-show');

      if ($listWrap.find('.s-more_loc').length > 0) {
        if (count === 2) {
          $listWrap.find('.s-more_loc').text(singularTxt);
        } else if (count > 2) {
          $listWrap.find('.s-more_loc').text(pluralTxt);
        }
      }

      moreItems = $listWrap.find('.s-more_list:gt(0)')
        .map(function () {
          return $(this).text();
        })
        .toArray();

      $listWrap.find('.s-more_list:gt(0)').hide();
      $listWrap.find('.s-more_num').text(count - 1);

      moreItems.forEach(item => {
        if ($listWrap.next().hasClass('s-more_baloon')) {
          $listWrap.next('.s-more_baloon').find('.s-more_baloon_list_wrap').append(`<li class="c-more_baloon_list">${item}</li>`);
        }
      });
      
    }
  });


  // baloon表示・非表示
  $('.s-more_text').on('click', function () {
    $(this).toggleClass('is-open');
    $(this).parent('.s-more_list_wrap').next('.s-more_baloon').toggleClass('is-open');
  });

  $('.s-more_baloon_close').on('click', function () {
    $(this).parent('.s-more_baloon').removeClass('is-open');
    $(this).parent('.s-more_baloon').prev('.s-more_list_wrap').find('.s-more_text').removeClass('is-open');
  });

  $(document).on('click.showMore', function (e) {
    const $currentTarget = $(e.target).closest('.s-more_list_wrap, .s-more_baloon');

    $('.s-more_baloon').each(function () {
      const $baloon = $(this);

      if (!$currentTarget.length || !$currentTarget.is($baloon) && !$currentTarget.is($baloon.prev('.s-more_list_wrap'))) {
        $baloon.removeClass('is-open');
        $baloon.prev('.s-more_list_wrap').find('.s-more_text').removeClass('is-open');
      }
    });
  });


  // 吹き出し三角部分の位置調整
  function adjustTrianglePosition($button) {
    $button.each(function () {
      const $targetButton = $(this);
      const buttonWidth = $targetButton.outerWidth();
      const buttonOffset = $targetButton.offset();
      const buttonCenter = buttonOffset.left + buttonWidth / 2;
      const $baloon = $targetButton.parent().next('.s-more_baloon');
      const triangleRelativePos = $baloon.find('.s-more_baloon_list_wrap').offset().left;
      const trianglePos = buttonCenter - triangleRelativePos;

      $baloon.find('.s-more_baloon_triangle').css('left', trianglePos + 13);
    });
  }

  // 初期位置調整
  $('.s-more_text').on('click', function () {
    adjustTrianglePosition($(this));
  });

  // 画面サイズ変更時に位置を再調整
  $(window).on('resize.showMore', function () {
    if ($('.s-more_baloon').hasClass('is-open')) {
      $('.s-more_text').each(function () {
        adjustTrianglePosition($(this));
      });
    }
  });
}